import DefaultLayout from "../components/layout/DefaultLayout";
import { connect } from "react-redux";
import { setCountry } from "../ducks/country";
import setCountryCookie from "../utils/setCountryCookie";
import GeoIP from "ms.geoip";

export function mapDispatchToProps(dispatch) {
    return {
        setCountryFromIP() {
            const geoIPClient = new GeoIP();

            geoIPClient.getGeoInfo().then(({ country }) => {
                setCountryCookie(country);

                dispatch(setCountry(country));
            });
        }
    };
}

const DefaultLayoutContainer = connect(
    null,
    mapDispatchToProps
)(DefaultLayout);

export default DefaultLayoutContainer;
